import Repository from "./masterRepository";
const getModules = "get";
const updateIntellectualProp = "updateIntellectualProp";

export default {
  getModules(payload) {
    return Repository.post(transformRoute(getModules), payload);
  },
  updateIntellectual(payload) {
    return Repository.post(transformRoute1(updateIntellectualProp), payload);
  },
};

const transformRoute = (route) => {
  return `admin/modules/${route}`;
};
const transformRoute1 = (route) => {
  return `intellectualproperty/${route}`;
};
